/**
* Tabbed Wysiwygs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Wysiwygs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-wysiwygs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      mobileDropdown();
      $( window ).on( 'resize', function() {
        mobileDropdown();
      } );
      let firstTabHeight = 0;

      $( '.tabbed-wysiwyg_content' ).each( function( i ) {
        if ( i === 0 ) {
          firstTabHeight = $( this ).height();
        }
        const contentHeight = $( this ).height();
        $( this ).data( 'height', contentHeight );
        $( this ).css( 'position', 'absolute' );
      } );

      $( '.tabbed-wysiwyg_content-wrapper' ).height( firstTabHeight );

      $( 'button.tabbed-wysiwygs_tab-button' ).on( 'click', function() {
        const target = $( this ).data( 'toggle-target' );
        const currentTabContentHeight = $( target ).data( 'height' );
        $( '.tabbed-wysiwyg_content-wrapper' ).height( currentTabContentHeight );
        console.log( currentTabContentHeight );
      } );

      function mobileDropdown() {
        if ( window.innerWidth < 768 ) {
          let open = false;
          $( '.mobile-dropdown' ).on( 'click', function() {
            if ( open === false ) {
              $( this ).addClass( 'is-open' );
              open = true;
            } else if ( open === true ) {
              $( '.mobile-dropdown' ).removeClass( 'is-open' );
              open = false;
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-wysiwygs', COMPONENT );
} )( app );
